export default __webpack_public_path__ + "static/media/Bullet 2.172d66e9.webp";